var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-checkbox',{staticClass:"custom-switch-color mb-0",attrs:{"id":'status-switch-' + _vm.id,"name":'status-switch-' + _vm.id,"switch":"","inline":"","color":"primary"},on:{"change":_vm.emitStatusChange},model:{value:(_vm.localActive),callback:function ($$v) {_vm.localActive=$$v},expression:"localActive"}})
}
var staticRenderFns = []

export { render, staticRenderFns }